import axios from 'axios'

const CheckupService = {
  async get (params = {}) {
    return axios.get('admin/checkups', { params })
  },

  async post (params = {}) {
    return axios.post('admin/checkups', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/checkups/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/checkups/${data.id}`, { data })
  }
}

export default CheckupService
